<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <v-card-title class="greyk lighten-4k">
          <h3>Fees Billing</h3>
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-btn color="success" @click="showB=!showB">Bill Classes</v-btn>
            </v-flex>

            <v-flex xs12>
              <v-card class="elevation-3">
                <v-card-title primary-title class="greyk lighten-4k">
                  <h4>Bills</h4>

                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                    style="max-width:40%"
                  ></v-text-field>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-data-table
                    :headers="billing_headers"
                    :items="bills"
                    class="elevation-0"
                    :search="search"
                    :loading="bloading"
                  >
                    <template v-slot:items="props">
                      <td class="text-xs-center">{{ props.index + 1 }}</td>
                      <td class="text-xs-center">{{ props.item.name }}</td>
                      <td class="text-xs-center">{{ props.item.feestr?props.item.feestr.name:'N/A' }}</td>
                      <td class="text-xs-center">{{ props.item.feestr?calcTotFees(props.item.feestr):'0.00' | toCurrency}}</td>
                      <td class="text-xs-center">{{ props.item.cf_acyear.year}}</td>
                      <td class="text-xs-center">{{ props.item.cf_term.name}}</td>

                      <td class="text-xs-center">
                        <v-layout row wrap>
                            <v-btn flat icon color="blue" @click="editclassbill(props.item)">
                              <v-icon>edit</v-icon>
                            </v-btn>
                        </v-layout>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <!-- Billing dialog -->
      <billing-dialog pers title="Billing" :show="showB">
        <template v-slot:header-actions>
          <v-btn @click="showB=!showB" icon style="cursor:pointer">
            <v-icon>close</v-icon>
          </v-btn>
        </template>

        <template v-slot:content>
          <v-form ref="form1">
            <v-autocomplete
              label="Select Fee Structure"
              prepend-icon="money"
              :items="feestrs"
              :loading="fsloading"
              v-model="feesbill_model.feestr_id"
              item-text="name"
              item-value="id"
              :rules="validRules.required"
            ></v-autocomplete>

            <v-autocomplete
              label="Select Classes"
              :multiple="true"
              prepend-icon="border_all"
              :items="unbilled_classes"
              item-text="name"
              item-value="id"
              :loading="cloading"
              v-model="feesbill_model.classes"
              :rules="validRules.required"
            ></v-autocomplete>
          </v-form>
        </template>

        <template v-slot:footer-actions>
          <v-btn
            style="cursor:pointer"
            color="success"
            @click="billClasses()"
            :loading="bloading"
          >Bill</v-btn>
          <v-btn @click="showB=!showB" style="cursor:pointer" color="error">close</v-btn>
        </template>
      </billing-dialog>

      <!--Edit Billing dialog -->
      <billing-dialog pers title="Edit Class Bill" :show="showEB">
        <template v-slot:header-actions>
          <v-btn @click="showEB=!showEB" icon style="cursor:pointer">
            <v-icon>close</v-icon>
          </v-btn>
        </template>

        <template v-slot:content>
          <v-form ref="form2">
            <v-text-field label="Class" prepend-icon="border_all" readonly v-model="edited_bill.name"></v-text-field>
            <v-autocomplete
              label="Select Fee Structure"
              prepend-icon="money"
              :items="feestrs"
              :loading="fsloading"
              v-model="cbillupdate_model.feestr_id"
              item-text="name"
              item-value="id"
              :rules="validRules.required"
            ></v-autocomplete>
          </v-form>
        </template>

        <template v-slot:footer-actions>
          <v-btn
            style="cursor:pointer"
            color="success"
            @click="updateclassbill()"
            :loading="bloading"
          >Save</v-btn>
          <v-btn @click="showEB=!showEB" style="cursor:pointer" color="error">close</v-btn>
        </template>
      </billing-dialog>
    </v-container>
  </v-layout>
</template>

<script>
import Modal from "../../../components/Modal";
import { mapGetters } from "vuex";
export default {
  name: "biils-view",
  metaInfo() {
    return { title: this.$t("fees") };
  },
  components: {
    "billing-dialog": Modal
  },
  mounted() {
    this.$store.dispatch("billings/getAll");
    this.$store.dispatch("classes/getAll");
    this.$store.dispatch("feestrs/getAll");
  },
  data() {
    return {
      search: "",
      showB: false,
      showEB: false,
      modal: false,
     
      feesbill_model: {
        classes: [],
        feestr_id: ""
      },
      feesbill_modelcp: {
        classes: [],
        feestr_id: ""
      },
      edited_bill: {},
      editedIndex: -1,
      cbillupdate_model: {
        class_id: "",
        feestr_id: ""
      },
      cbillupdate_modelcp: {
        class_id: "",
        feestr_id: ""
      },

      billing_headers: [
        {
          text: "SN",
          align: "center",
          sortable: true,
          value: "sn"
        },
        {
          text: "Class",
          align: "center",
          sortable: true,
          value: "level"
        },
        {
          text: "Fee Structure",
          align: "center",
          sortable: true,
          value: "feestr"
        },
        {
          text: "Total Amount(GHS)",
          align: "center",
          sortable: false,
          value: "amount"
        },
        ,
        {
          text: "Academic Year",
          align: "center",
          sortable: false,
          value: "acyear"
        },
        {
          text: "Term",
          align: "center",
          sortable: false,
          value: "term"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "name"
        }
      ]
    };
  },
  methods: {
    async billClasses() {
       if (!this.$refs.form1.validate()) {
        return;
      }

      if(this.feesbill_model.classes&&this.feesbill_model.classes.length<=0){
         this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: "please select classes to bill.",
                title: "Billing",
                modal: false
            })

            return
      }
     await this.$store.dispatch("billings/add", this.feesbill_model);


      if (this.berrors ==null) {
        //this.$store.dispatch("billings/getAll");
        this.feesbill_model = this.feesbill_modelcp;
        this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Classes have been billed successfully.",
                title: "Billing",
                modal: false
            })

        this.showB = false
        this.$router.go();
        // setTimeout(()=>{
        //   window.location.reload();
        // },1000)
      }else{
        this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: "Sorry an error occurred and billing was unsuccessfully.",
                title: "Billing",
                modal: false
            })
      }
    },
    editclassbill(bill) {
      this.editedIndex = this.bills.indexOf(bill);
      this.edited_bill = bill
      this.cbillupdate_model.class_id = bill?bill.id:''
      this.cbillupdate_model.feestr_id = bill.feestr?bill.feestr.id:''

      //alert(this.editedIndex)

      this.showEB = true;
    },
    updateclassbill() {
       if (!this.$refs.form2.validate()) {
        return;
      }
      this.$store.dispatch("billings/update", {
        index:this.editedIndex,
        bill: this.cbillupdate_model
      });

      if (this.berrors ==null) {
        this.cbillupdate_model = this.cbillupdate_modelcp;
        this.editedIndex = -1;
        this.edited_bill={};
        this.showEB = false;
        this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Class bill updated successfully.",
                title: "Billing",
                modal: false
            })
      }else{
        this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: "Sorry, class bill could not be updated",
                title: "Billing",
                modal: false
            })
      }
    },
    calcTotFees(feestr) {
      // console.log(feestr)
      let basic_amt = feestr.basic_amt;
      let adchargeSum = feestr.adcharges.reduce((sum, val) => {
        return parseFloat(sum) + parseFloat(val.amount);
      }, 0);

      return parseFloat(basic_amt) + parseFloat(adchargeSum);
    }
  },
  computed: {
    ...mapGetters({
      classes: "classes/CLASSES",
      cerrors: "classes/CLASS_ERROR",
      cloading: "classes/CLASS_LOADING",

      feestrs: "feestrs/FEESTRS",
      fserrors: "feestrs/FEESTR_ERROR",
      fsloading: "feestrs/FEESTR_LOADING",

      bills: "billings/BILLINGS",
      bloading: "billings/BILLING_LOADING",
      berrors: "billings/BILLING_ERROR"
    }),
    unbilled_classes(){
      let billed_classes = this.bills.map(x => x.id);
      return this.classes.filter(
        i => !billed_classes.includes(i.id)
      );
    }
  },
  // watch: {
  //   classes(val){
      
  //    // console.log(billed_classes)
  //   },
  //   bills(val) {
  //     //console.log(this.classes)
      
  //     //console.log(billed_classes)
  //     //this.unbilled_classes = 
  //   }
  // }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/accountant/billing/billing.vue